import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";

export function PromptForConfirmationModal(props: {
  onConfirm: () => void;
  onClose: () => void;
  request: string;
  confirmButtonTitle?: string;
  abortButtonTitle?: string;
  colorScheme?: string;
}) {
  return (
    <Modal closeOnOverlayClick={true} isOpen={true} onClose={props.onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Verifiera</ModalHeader>
        <ModalCloseButton />
        <ModalBody margin={"20px"}>
          <Text fontSize={"20px"}>{props.request}</Text>
        </ModalBody>
        <ModalFooter borderRadius={"0px"} background={"blue.100"}>
          <HStack width={"100%"}>
            <Button
              padding={"20px"}
              width={"100%"}
              type="button"
              onClick={() => {
                props.onConfirm();
                props.onClose();
              }}
              colorScheme={props.colorScheme ?? "green"}
            >
              {props.confirmButtonTitle ?? "JA"}
            </Button>
            <Button
              type="button"
              padding={"20px"}
              width={"100%"}
              onClick={props.onClose}
            >
              {props.abortButtonTitle ?? "NEJ"}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

function cleanFileName(name: string) {
  return `${name
    .replace(".pdf", "")
    .replace(".", ",")
    .replace(/\s+/, "_")}.pdf`;
}
